import firebase from './firebase'
import moment from 'moment'
import User from '@/types/User'

const auth = firebase.auth()

export default class FirebaseAuth {
  async signinWithGoogle(): Promise<User> {
    const provider = new firebase.auth.GoogleAuthProvider();
    await auth.signInWithPopup(provider)
    return this.getUser()
  }

  async signin(): Promise<User> {
    await auth.signInAnonymously()
    return this.getUser()
  }

  firebaseUserToUser(fbuser: firebase.User): User {
    return {
      id: fbuser.uid,
      lastSigninAt: moment(fbuser.metadata.lastSignInTime),
      createdAt: moment(fbuser.metadata.creationTime),
      providerData: fbuser.providerData,
    }
  }

  getUser(): Promise<User> {
    return new Promise((resolve, reject) => {
      if (auth.currentUser) {
        return resolve(this.firebaseUserToUser(auth.currentUser))
      }
      const unsubscribe = auth.onAuthStateChanged((user) => {
        console.log('subscribe')
        unsubscribe()
        if (!user) return reject('no-user')
        resolve(this.firebaseUserToUser(user))
      })
    })
  }

  signout() {
    return auth.signOut()
  }
}
